<ion-content class="results-screen tw-pt-[16px] tw-pb-[16px] tw-pr-[30px] tw-pl-[30px]">

  <!-- Heading -->
  <div class="heading-section tw-relative">
    <ion-icon
      name="arrow-back-outline"
      (click)="close()"
      class="soft-back tw-text-[20px] tw-text-white tw-p-[5px] tw-absolute"
    />
    <ion-title class="tw-text-center"
      class="
      tw-text-center
      tw-text-[20px]
      tw-font-bold
    ">
      Results
    </ion-title>
    <span (click)="close()"
      class="
      close
      tw-absolute
      tw-capitalize
      tw-text-[16px]
    ">
      Close
    </span>
  </div>

  <!-- Results -->
  <div class="my-results-section">

    <div class="bettingResults-content">
      <!-- Betting Results -->
      <div
        (click)="showLatestFinishedEvent()"
        class="bettingResults results-row"
        data-name="bettingResults"
      >
        <img
          src="/assets/images/wager/bet_result_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
        >
        <img
          src="/assets/images/wager/bet_result_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <span slot="start" class="tw-text-[16px]">Betting Results</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Replays and Search -->
      <div
        (click)="selectResults('replays')"
        class="replays results-row"
        data-name="replays"
      >
        <img
          src="/assets/images/wager/replays_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
        >
        <img
          src="/assets/images/wager/replays_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <span slot="start" class="tw-text-[16px]">Replays and Search</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>
    </div>

    <!-- Dynamic Content -->
    <div #content class="content">

      <!-- Betting Results -->
      <div class="bettingResults card-content card-hide" data-name="bettingResults">
        <!-- <feature-ion-statements *ngIf="controller.bettingResults"></feature-ion-statements> -->
      </div>

      <!-- Replays and Search -->
      <div class="replays card-content card-hide" data-name="replays">
        <!-- <feature-ion-statements *ngIf="controller.replays"></feature-ion-statements> -->
        <feature-ion-replays-and-search *ngIf="controller.replays"></feature-ion-replays-and-search>
      </div>
    </div>

  </div>

</ion-content>
